import React from "react";
import Bet from "../Bet/Bet";
import { Scrollbars } from "react-custom-scrollbars";

export default class Bets extends React.PureComponent {
  static defaultProps = {
    bets: []
  };

  render() {
    const { bets } = this.props;
    return (
      <Scrollbars className="crash-bets" hideTracksWhenNotNeeded={true} autoHeight={window.innerWidth <= 600}>
        {Object.keys(bets).map(id =>
          <Bet {...bets[id]} key={id} />
        )}
      </Scrollbars>
    );
  }
}


// WEBPACK FOOTER //
// ./app/components/CrashGame/Bets/Bets.jsx